// src/pages/AdminPanel.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';

const AdminContainer = styled.div`
  padding: 20px;
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
`;

const ImageCard = styled.div`
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const ImageActions = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  gap: 10px;
`;

const DeleteButton = styled.button`
  background: red;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
`;

const AdminPanel = ({ user }) => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminAndLoadImages = async () => {
      try {
        setLoading(true);
        const token = await user.getIdToken();
        
        // First check if user is admin
        const adminResponse = await axios.get(`${process.env.REACT_APP_API_URL}/admin/check`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        setIsAdmin(adminResponse.data.isAdmin);
        
        if (adminResponse.data.isAdmin) {
          // Fetch all public images
          const imagesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/all-images`);
          setImages(imagesResponse.data.images);
        }
      } catch (err) {
        console.error("Admin panel error:", err);
        setError("You don't have admin access");
      } finally {
        setLoading(false);
      }
    };
    
    checkAdminAndLoadImages();
  }, [user]);

  const handleDeleteImage = async (imageId) => {
    try {
      const token = await user.getIdToken();
      await axios.delete(`${process.env.REACT_APP_API_URL}/admin/images/${imageId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      // Remove the deleted image from state
      setImages(images.filter(img => img.id !== imageId));
    } catch (err) {
      console.error("Error deleting image:", err);
      setError("Failed to delete image");
    }
  };

  if (loading) return <div>Loading admin panel...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!isAdmin) return <div>Unauthorized: Admin access required</div>;

  return (
    <AdminContainer>
      <h1>Admin Panel</h1>
      <h2>Public Gallery Management</h2>
      
      <ImageGrid>
        {images.map(image => (
          <ImageCard key={image.id}>
            <img 
              src={image.image_url} 
              alt={image.prompt} 
              style={{ width: '100%', height: '200px', objectFit: 'cover' }} 
            />
            <p><strong>By:</strong> {image.anonymous_username}</p>
            <p><strong>Prompt:</strong> {image.prompt}</p>
            <ImageActions>
              <DeleteButton onClick={() => handleDeleteImage(image.id)}>
                Delete
              </DeleteButton>
            </ImageActions>
          </ImageCard>
        ))}
      </ImageGrid>
    </AdminContainer>
  );
};

export default AdminPanel;